import { useRequest } from "@certn/api";
import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  showToast,
} from "@certn/cascadia-react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Schemas } from "../../types";

interface InvoicesActionsDropdownMenuProps {
  invoiceId: string;
}

export function InvoicesActionsDropdownMenu(
  props: InvoicesActionsDropdownMenuProps
) {
  const { t } = useTranslation();
  const { invoiceId } = props;
  const navigate = useNavigate();
  const request = useRequest();
  const { enableInvoicePayments } = useFlags();

  const downloadUsageReportCSV = async (invoiceId: string) => {
    try {
      const response = await request<Schemas["UsageReportCsvResponse"]>(
        `/api/internal/client-portal/invoices/${invoiceId}/usage-report/`,
        {
          method: "GET",
        }
      );

      window.open(response.usage_report, "_blank");
    } catch {
      showToast(t("Unable to open usage report"), { type: "error" });
    }
  };

  return (
    <DropdownMenu
      placement="bottom end"
      triggerButton={
        <GhostIconButton
          testID="invoice-expand-menu-button"
          size="small"
          icon="more_vert"
          aria-label={t("Expand menu")}
        />
      }
      onItemAction={(key) => {
        switch (key) {
          case "view-invoice":
            window.open(
              `/billing/invoices/${invoiceId}`,
              "_blank",
              "noopener,noreferrer"
            );
            break;
          case "download-usage-report":
            downloadUsageReportCSV(invoiceId);
            break;
          case "pay-invoice":
            navigate(invoiceId);
            break;
        }
      }}
    >
      {enableInvoicePayments && (
        <MenuItem
          id="pay-invoice"
          testID="invoice-table-expand-pay-invoice-button"
        >
          <Trans>Pay invoice</Trans>
        </MenuItem>
      )}
      <MenuItem
        id="view-invoice"
        testID="invoice-table-expand-view-invoice-button"
      >
        <Trans>View invoice</Trans>
      </MenuItem>
      <MenuItem
        id="download-usage-report"
        testID="invoice-table-expand-download-invoice-button"
      >
        <Trans>Download usage report</Trans>
      </MenuItem>
    </DropdownMenu>
  );
}
